

































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Checkbox from '@/components/inputsV2/Checkbox.vue'

import { FacilityModule } from '@/store/modules/facility.module'
import ModalV2 from '@/components/modals/ModalV2.vue'
import Icon from '@/components/Icon.vue'
import { getTooltipListText } from '@/utils/helpers'

@Component({
  props: {
    facility: {
      type: Object,
      required: true
    }
  },
  components: {
    Icon,
    ModalV2,
    Checkbox
  }
})
export default class UpdateFacilityModal extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  getTooltipListText: Function = getTooltipListText

  updateInfo: boolean = false
  updateResidents: boolean = false
  updateTransactions: boolean = false

  isLoading: boolean = false

  async updateFacility () {
    try {
      this.isLoading = true
      const facilityHasActivePayers = this.facilityModuleInstance.facilityCompleteLevels.payers === 100
      if (this.updateTransactions && !facilityHasActivePayers) {
        throw new Error(`No active payers to update transactions`)
      }
      const response = await this.facilityModuleInstance.fetchFacilityUpdates({
        facilityId: this.$props.facility.id,
        options: {
          updateFacilityDetails: this.updateInfo,
          updateFacilityResidentContactTypes: this.updateInfo,
          updateFacilityPayerTypes: this.updateInfo,
          updateResidents: this.updateResidents,
          updateTransactions: this.updateTransactions
        }
      })
      if (response === 'OK') {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-success-color)',
          message: 'Process Started',
          header: `Update Facility...`,
          icon: 'check'
        })
      } else {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: 'Process Failed',
          header: `Update Facility...`,
          icon: 'warning'
        })
      }
    } catch (err) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: err.message,
        header: `Update Facility...`,
        icon: 'warning'
      })
    } finally {
      this.isLoading = false
      this.$emit('close')
    }
  }

  getTooltipText (section: string) {
    let points: string[] = []
    switch (section) {
      case 'info':
        points = ['Payers', 'Contact Types', 'Facility Name & Address']
        break
      case 'residents':
        points = ['Residents', 'Recipients']
        break
      case 'transactions':
        points = ['Residents', 'Recipients', 'Transactions', 'Balances']
        break
    }

    return this.getTooltipListText(points)
  }
}
